import {Pipe, PipeTransform} from '@angular/core';

type TimeUnit = 'year' | 'month' | 'week' | 'day' | 'hour' | 'minute' | 'second';

@Pipe({
    name: 'relativeTime',

})
export class RelativeTimePipe implements PipeTransform {

    transform(
        value: string | number | Date,
        options?: { maxUnit?: TimeUnit; mobile?: boolean }
    ): string {

        if (!value) return '';

        const isMobile = options?.mobile ?? window.innerWidth <= 1000;
        const maxUnit = options?.maxUnit;

        const dateTime = new Date(value);
        const now = new Date();
        const diff = dateTime.getTime() - now.getTime();

        const seconds = Math.floor(Math.abs(diff) / 1000);
        const minutes = Math.floor(seconds / 60);
        const hours = Math.floor(minutes / 60);
        const days = Math.floor(hours / 24);
        const weeks = Math.floor(days / 7);
        const months = Math.floor(days / 30);
        const years = Math.floor(months / 12);

        const units: { unit: TimeUnit; value: number }[] = [
            {unit: 'year', value: years},
            {unit: 'month', value: months},
            {unit: 'week', value: weeks},
            {unit: 'day', value: days},
            {unit: 'hour', value: hours},
            {unit: 'minute', value: minutes},
            {unit: 'second', value: seconds}
        ];

        let selected = units.find(u => u.value > 0) || units[units.length - 1];

        // Apply maxUnit cap
        if (maxUnit) {
            const maxIndex = units.findIndex(u => u.unit === maxUnit);
            const currentIndex = units.findIndex(u => u.unit === selected.unit);

            if (currentIndex < maxIndex) {
                selected = units[maxIndex];
            }
        }

        const label = isMobile
            ? this.getMobileLabel(selected.unit)
            : this.getFullLabel(selected.unit, selected.value);

        let result = `${selected.value}${label}`;

        return diff > 0 ? `in ${result}` : `${result} ago`;
    }

    private getMobileLabel(unit: TimeUnit): string {
        const map: Record<TimeUnit, string> = {
            year: 'y',
            month: 'mo',
            week: 'w',
            day: 'd',
            hour: 'h',
            minute: 'm',
            second: 's'
        };
        return map[unit];
    }

    private getFullLabel(unit: TimeUnit, value: number): string {
        return ` ${unit}${value !== 1 ? 's' : ''}`;
    }
}
